<div class="login-page">
    <div class="login-box">
        <form (ngSubmit)="login()" *ngIf="!showForgotPassword">
            <a class="logo-lg" href="">
                <img src="./assets/images/logo.svg" alt="">
            </a>

            <h1>Login</h1>
            <h4>Welcome Back</h4>
            <div class="form-group  mb-3">
                <mat-label>Email Address  <span class="required">*</span></mat-label>
                <mat-form-field class="">
                    <input matInput type="text" [formControl]="email" [(ngModel)]="loginModel.email" placeholder="Email Address" />
                    <span matSuffix class="input-icon">
                        <img src="./assets/images/icon-email.svg" alt="">
                    </span>
                </mat-form-field>
                <div *ngIf="email.touched && email.invalid" class="mat-mdc-form-field-error pt-2 pb-3">
                    <small *ngIf="email.errors?.['required']">Email is required.</small>
                    <small *ngIf="email.errors?.['email']">Invalid Email</small>
                </div>
            </div>
            <div class="form-group forgot-password-section mb-3">
                <mat-label>Password  <span class="required">*</span></mat-label>
                <mat-form-field class="">
                    <input matInput [type]="hide() ? 'password' : 'text'" [formControl]="password" [(ngModel)]="loginModel.password" placeholder="Password" />
                    <a href="javascript:void(0)" 
                        mat-icon-button
                        matSuffix
                        (click)="clickEvent($event)"
                        [attr.aria-label]="'Hide password'"
                        [attr.aria-pressed]="hide()"
                        >
                        <mat-icon>{{hide() ? 'visibility_off' : 'visibility'}}</mat-icon>
                        </a>
                </mat-form-field>
                <div *ngIf="password.touched && password.invalid" class="mat-mdc-form-field-error pt-2 pb-3">
                    <small *ngIf="password.errors?.['required']">Password is required.</small>
                </div>
            </div>
            <div class="d-flex justify-content-between align-items-center">
                <mat-checkbox [formControl]="rememberMe" [(ngModel)]="loginModel.rememberMe" id="rememberMe" class="example-margin">Remember me</mat-checkbox>

                <a href="javascript:void(0)" class="forgot-password"  (click)="toggleForgotPassword()">
                    Forgot password?
                </a>
            </div>
            <button class="mt-2 m-l-10 pull-right me-3" mat-raised-button color="primary"> Login </button>
        </form>
        <div *ngIf="showForgotPassword">
            <form (ngSubmit)="forgotPassword()">
                <a class="logo-lg" href="">
                    <img src="./assets/images/logo.svg" alt="">
                </a>
                <h1>Forgot Password</h1>
                <div class="form-group mb-3">
                    <mat-lable for="">Email Address  <span class="required">*</span></mat-lable>
                    <mat-form-field class="">
                        <input matInput type="text" [formControl]="email" [(ngModel)]="forgotPasswordModel.emailId" placeholder="Email Address" />
                        <span matSuffix class="input-icon">
                            <img src="./assets/images/icon-email.svg" alt="">
                        </span>
                    </mat-form-field>
                    <div *ngIf="emailId.touched && emailId.invalid" class="mat-mdc-form-field-error pt-2 pb-3">
                        <small *ngIf="emailId.errors?.['required']">Email is required.</small>
                        <small *ngIf="emailId.errors?.['emailId']">Invalid Email</small>
                    </div>
                </div>
                <button class="mt-2 m-l-10 pull-right me-3" mat-raised-button color="primary"> Submit </button>
                <button class="mt-2 m-l-10 pull-right me-3 btn-black" mat-raised-button color="primary" (click)="cancelForgotPassword()"> Cancel </button>
            </form>
        </div>
    </div>
    <div class="copy-right">
        © {{ currentYear }} {{ 'FOOTER_TEXT' | translate }}
    </div>
</div>